// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
function IconArrival(Props) {
  var className = Props.className;
  var strokeWidthOpt = Props.strokeWidth;
  var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "2";
  return React.createElement("svg", {
    className: className,
    height: "15",
    width: "11",
    fill: "none",
    viewBox: "0 0 11 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M5.25 0.75C2.32422 0.75 0 3.10156 0 6C0 8.13281 0.710938 8.73438 4.70312 14.4766C4.83984 14.668 5.03125 14.75 5.25 14.75C5.44141 14.75 5.63281 14.668 5.76953 14.4766C9.76172 8.70703 10.5 8.13281 10.5 6C10.5 3.10156 8.14844 0.75 5.25 0.75ZM5.25 13.7109C1.39453 8.1875 0.875 7.75 0.875 6C0.875 3.59375 2.81641 1.625 5.25 1.625C7.65625 1.625 9.625 3.59375 9.625 6C9.625 7.75 9.07812 8.16016 5.25 13.7109ZM5.25 3.8125C4.01953 3.8125 3.0625 4.76953 3.0625 6C3.0625 7.20312 4.01953 8.1875 5.25 8.1875C6.45312 8.1875 7.4375 7.20312 7.4375 6C7.4375 4.76953 6.45312 3.8125 5.25 3.8125ZM5.25 7.3125C4.51172 7.3125 3.9375 6.71094 3.9375 6C3.9375 5.26172 4.51172 4.6875 5.25 4.6875C5.96094 4.6875 6.5625 5.26172 6.5625 6C6.5625 6.71094 5.96094 7.3125 5.25 7.3125Z",
    fill: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }));
}
IconArrival.displayName = "IconArrival";
var make = IconArrival;
export { make };
/* react Not a pure module */